
import Vue from 'vue';
import Tag from '@/components/Tag/index.vue';
import { CardContainer, Grid } from './styles';

export default Vue.extend({
  components: {
    CardContainer,
    Grid,
    Tag,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
});
